export default {"src":"/_next/static/media/0x0000206329b97db379d5e1bf586bbdb969c63274.e0a6d18a.svg","height":195,"width":195,"blurWidth":0,"blurHeight":0};